import React, { useState, useContext } from 'react'
import { AuthContext } from '../../contexts/auth'
import { Header } from '../../components/header/header'
import logo from '../../images/logo-icon.png'
import * as yup from 'yup'
import LoadContainer from '../../components/loading'
import './styles.css'
import { ErrorMessage, Field, Form, Formik } from 'formik'

const schema = yup.object().shape({
	email: yup.string().email('Formato de email inválido').required('Campo Obrigatório.'),
	password: yup.string().required('Campo Obrigatório.').min(3, 'A senha deve conter no mínimo 3 caracteres'),
})

const Login = () => {
	const { login } = useContext(AuthContext)
	const [isSubmitting, setSubmitting] = useState(false)

	const onSubmit = (values) => {
		setSubmitting(true)
		login(values)
			.then((response) => {})
			.catch((err) => {
				console.log(err)
			})
			.finally(() => {
				setSubmitting(false)
			})
	}

	return (
		<div id="login">
			<Header></Header>
			<Formik
				initialValues={{
					email: '',
					password: '',
				}}
				validationSchema={schema}
				onSubmit={onSubmit}
			>
				<Form className="form">
					<img className="login-logo" alt="schiefler logo" src={logo} />
					<h1 className="formTitle">Login</h1>
					<div className="field">
						<label className="labels" htmlFor="email">
							Email:
						</label>
						<div className="div-icons">
							<span className="material-symbols-outlined icons">person</span>
							<Field
								placeholder="Digite seu email"
								className="field"
								type="email"
								id="email"
								name="email"
							/>
						</div>
					</div>
					<ErrorMessage name="email" component="div" className="error" />

					<div className="field">
						<label className="labels" htmlFor="password">
							Senha:
						</label>
						<div className="div-icons">
							<span className="material-symbols-outlined icons">lock</span>
							<Field
								placeholder="Digite sua senha"
								className="field"
								type="password"
								id="password"
								name="password"
							/>
						</div>
					</div>
					<ErrorMessage name="password" component="div" className="error" />

					<div className="actions">
						<button type="submit">Entrar</button>
						<span className="error-message error" />
						{isSubmitting ? <LoadContainer /> : null}
					</div>
				</Form>
			</Formik>
		</div>
	)
}

export default Login
